
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 24a.75.75 0 01-.75-.75v-1.702a14.985 14.985 0 01-1.152-1.85.801.801 0 01-.06-.152 6.216 6.216 0 01-.192-1.08l-.043.031a.652.652 0 01-.087.053c-.275.144-.604.22-.952.22-.417 0-.828-.11-1.157-.309-.545-.33-.857-.895-.857-1.55V14.25H3.75A2.252 2.252 0 011.5 12V2.25A2.252 2.252 0 013.75 0h16.5a2.252 2.252 0 012.25 2.25V12a2.252 2.252 0 01-2.25 2.25h-4.5a.75.75 0 01-.75-.75V9.375c0-.62-.505-1.125-1.125-1.125s-1.125.505-1.125 1.125v5.1a.746.746 0 01-.023.183l-.488 1.948a4.873 4.873 0 00-.024 2.469c.33.618.711 1.215 1.133 1.773.098.129.152.29.152.452v1.2h5.248c-.002-.518-.007-.953-.011-1.327v-.035c-.025-2.221-.026-2.354.592-4.868a.75.75 0 111.457.358c-.573 2.329-.573 2.329-.549 4.493.006.552.014 1.237.014 2.128a.75.75 0 01-.75.75H12.75zM9 16.912c0 .155.049.215.134.266.095.057.232.09.377.09a.692.692 0 00.226-.033c.527-.392.935-.92 1.182-1.531l.331-1.323v-.131H9v2.662zm11.25-4.162A.75.75 0 0021 12V2.25a.75.75 0 00-.75-.75H3.75a.75.75 0 00-.75.75V12c0 .414.336.75.75.75h7.5V9.375c0-1.447 1.177-2.625 2.625-2.625S16.5 7.928 16.5 9.375v3.375h3.75z"}}),_c('path',{attrs:{"d":"M12.9 4.5a.75.75 0 010-1.5h5.85a.75.75 0 010 1.5H12.9zM7.5 9.375c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5S9 7.202 9 6.375s-.673-1.5-1.5-1.5z"}})])
          )
        }
      }
    